<template>
  <div>
    <v-autocomplete :ref="option.code" :dense="dense" :outlined="outlined" :hide-details="hideDetails" :label="option.name" v-model="refId" :disabled="disabled" :rules="rules" :clearable="!option.required" :item-text="nameAttr" no-filter :hide-no-data="!searchValue" item-value="ID" :items="dataList" :multiple="option.multi" append-icon="mdi-magnify" @click:clear="onClear" @click:append="onRefIconClick" @change="onValueChanged" @update:search-input="onSearchValueChanged">
      <!-- <v-icon :disabled="disabled" text slot="append" :color="disabled ? 'default' : 'primary'" @click="onRefIconClick">search</v-icon> -->
    </v-autocomplete>

    <v-dialog v-model="refModelVisible" scrollable max-width="680" persistent>
      <v-card>
        <v-card-title>
          参照选择
          <v-spacer />
          <v-text-field ref="refModelSearchInput" v-model="searchValue" @click:append="onRefModelDataQuery()" @keydown="(e)=>{if(e.keyCode==13)this.onRefModelDataQuery()}" placeholder="搜索" append-icon="mdi-magnify" outlined rounded hide-details dense></v-text-field>
        </v-card-title>
        <v-card-text style="height:330px;">
          <template v-if="!optionLoaded">
            <v-skeleton-loader type="article"></v-skeleton-loader>
          </template>
          <template v-else>
            <v-data-table :dense="tableOption.dense" v-if="refPageMode=='R1'" item-key="ID" :items-per-page="refModel.queryParam.pagination.size" :server-items-length="refModel.queryParam.pagination.total" :footer-props="{itemsPerPageOptions:refModel.pageSizeOption}" :headers="refModel.columns" :items="refModel.dataList" v-model="refModel.selectedRows" multi-sort show-select :single-select="!option.multi" @update:options="onRefModelDataQuery" @click:row="onRowClick">
            </v-data-table>
            <template v-else-if="refPageMode=='R2'">
              <v-treeview v-if="option.multi" return-object dense item-key="ID" selectable selection-type="independent" :item-text="nameAttr" :items="refModel.dataList" v-model="refModel.selectedRows" @input="onTreeInput">
              </v-treeview>

              <v-treeview v-else return-object dense activatable item-key="ID" :active.sync="refModel.selectedRows" :item-text="nameAttr" :items="refModel.dataList" @update:active="onTreeActive">
              </v-treeview>
            </template>

            <template v-if="option.multi">
              <v-card class="mt-2 mb-4">
                <v-card-text>
                  <template v-if="refModel.selectedRows.length">
                    <v-chip v-for="(sr,index) in refModel.selectedRows" close class="mr-2" :key="index" @click:close="refModel.selectedRows.splice(index,1)">{{sr[nameAttr]}}</v-chip>
                  </template>
                  <template v-else>
                    <div>没有选择数据</div>
                  </template>
                </v-card-text>
              </v-card>
            </template>
          </template>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="onRefCancel">取消</v-btn>
          <v-btn color="primary" @click="onRefOk">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { debounce } from 'throttle-debounce';
import Vue from 'vue';
import EditorProps from '../EditorProps';
export default {
  name: 'ref-editor',
  props: {
    option: { type: Object, required: true, default: () => ({}) },
    billData: { required: true },
    ...EditorProps.vuetify
  },
  data () {
    return {
      searchValue: null,
      dataList: [],
      refId: null,
      pagination: { size: 10, index: 1, total: 0 },
      dataLoading: false,

      optionLoaded: false,
      refModelVisible: false,
      refData: [], // 参照值
      refModel: {
        pageOption: {},
        pageSizeOption: [10, 20, 50],
        queryParam: { pagination: { size: 20, index: 1, total: 0 } },
        dataList: [],
        selectedRows: []
      }
    }
  },
  watch: {
    refModelVisible (value) {
      if (value && this.optionLoaded) this.onRefModelDataQuery();
    },
    'option.refPage': {
      deep: true,
      handler: function () {
        this.optionLoaded = false;
        this.refModel.selectedRows = [];
      }
    },
    optionLoaded (value) {
      if (value) {
        if (this.refPageMode == 'R1') {
          this.refModel.columns = this.Framework.getTableColumns(this.tableOption);
          this.refModel.queryParam.pagination = { size: 20, index: 1, total: 0 };
        } else if (this.refPageMode == 'R2') {
          delete this.refModel.queryParam.pagination;
        }
      }
    }
  },
  computed: {
    refPageMode: function () {
      return this.refModel.pageOption.mode;
    },
    treeOption: function () {
      return this.refModel.pageOption.cpts.find(cpt => cpt.type == 2);
    },
    tableOption: function () {
      return this.refModel.pageOption.cpts.find(cpt => cpt.type == 1);
    },
    nameAttr: function () {
      return this.option.refNameAttr || 'NAME';
    },
    coder: function () {
      return this.optionLoaded ? this.refModel.pageOption.coder : {};
    }
  },
  methods: {
    // override
    focus () {
      this.$refs[this.option.code].focus();
    },
    onSearchInputDataQuery (option) {
      this.dataList = [];
      let xOption = this.refPageMode == 'R2' ? this.treeOption : this.tableOption;
      let dto = { loading: false, pageCode: this.option.refPage, cptCode: xOption.code, version: xOption.version };
      dto.pagination = {
        index: !option ? 1 : option.page,
        size: !option ? 10 : option.itemsPerPage
      };
      let condition = this._getCondition();
      dto.condition = condition;
      this.Framework.dataQuery(dto).then(res => {
        let d = res.data || [];
        this.Framework.processDataList(d, this.coder, xOption);
        this.pagination.total = res.pagination.total;
        this.dataList = d;
      })
    },
    onValueChanged (e) {
      let value = [];
      if (e || (this.option.multi && e.length)) {
        if (this.option.multi) e.forEach(id => value.push(this.Utility.findById(this.dataList, id)));
        else value = [this.Utility.findById(this.dataList, this.refId)];
      }
      this.$set(this.billData, this.option.code, this.option.multi ? value : value[0]);
      this.$emit('change', this.option.multi ? value : value[0]);
    },
    onRefIconClick () { // 参照框: 图标点击事件（弹出参照页面）
      let callback = () => this.refModelVisible = true;
      if (!this.optionLoaded) {
        this._doLoadPageOption(callback);
      } else callback();
    },
    onRefCancel () { // 参照页面: 取消点击事件
      this.refModelVisible = false;
    },
    onClear () { // 参照框: 清除图标点击事件
      this.dataList = [];
      this.$set(this.billData, this.option.code, null);
    },
    onRefOk () { // 参照页面: 确定点击事件
      if (this.refModel.selectedRows.length == 0) {
        this.$message.error('请选择参照数据');
        return;
      }
      this.refData = [...this.refModel.selectedRows];
      this._setRefValue();
      this.refModelVisible = false;
    },
    onRefModelDataQuery (option) { // 参照页面: 数据查询
      if (this.dataLoading) return;
      this.dataLoading = true;
      let xOption = this.refPageMode == 'R2' ? this.treeOption : this.tableOption;
      let dto = { pageCode: this.option.refPage, cptCode: xOption.code, version: xOption.version };
      if (this.refPageMode == 'R2') { // TODO 树形数据查询
      } else {
        dto.pagination = {
          index: !option ? 1 : option.page,
          size: !option ? 20 : option.itemsPerPage
        }
      }
      let sort = this._getSort(option);
      let condition = this._getCondition();
      dto.sort = sort;
      dto.condition = condition;
      this.Framework.dataQuery(dto).then(res => {
        let d = res.data || [];
        if (this.refPageMode == 'R2') {
          this.refModel.dataList = this.Utility.toTree(d);
        } else {
          this.Framework.processDataList(d, this.coder, xOption);
          this.refModel.dataList = d;
          this.refModel.queryParam.pagination.total = res.pagination.total;
        }
      }).finally(() => { this.dataLoading = false; });
    },
    onRowClick (row) {
      if (!this.Utility.findById(this.refModel.selectedRows, row['ID'])) {
        if (this.option.multi) {
          this.refModel.selectedRows.push(row);
        } else {
          this.refModel.selectedRows.splice(0, 1, row);
        }
      }
    },
    onTreeActive (rows) {
      if (!rows.length) return;
      if (this.option.multi) {
        if (!this.Utility.findById(this.refModel.selectedRows, rows[0]['ID'])) this.refModel.selectedRows.push(rows[0]);
      } else {
        this.refModel.selectedRows = rows;
      }
    },
    onTreeInput (rows) {
      this.refModel.selectedRows = rows;
    },
    setCondition (condition) {
      this.refModel.queryParam.condition = condition;
    },
    _getCondition () {
      let refCondition = this.Utility.clone(this.refModel.queryParam.condition);
      let ret;
      if (this.searchValue) {
        let hf = !this.Utility.isNull(refCondition), fromIdx = hf ? refCondition.items.length : 0;
        let conditionItems = [];
        let cptOption = this.refPageMode == 'R2' ? this.treeOption : this.tableOption;
        let searchItems = cptOption.searchItems.filter(item => !item.fixd), stcOr = [];
        if (!searchItems || !searchItems.length) {
          searchItems = [
            { path: cptOption.mdCode + '.CODE', type: 1, dftOpc: 4 },
            { path: cptOption.mdCode + '.NAME', type: 1, dftOpc: 4 }
          ];
        }
        for (let i = 0, l = searchItems.length; i < l; i++) {
          let si = searchItems[i];
          conditionItems.push({ code: si.path || si.code, type: si.type, opc: si.dftOpc, values: [this.searchValue] });
          stcOr.push(++fromIdx);
        }
        let stc = stcOr.join(' or ');
        if (hf) {
          let items = [...refCondition.items, ...conditionItems];
          stc = refCondition.stc + ' and (' + stc + ')';
          ret = { stc: stc, items: items };
        } else ret = { stc: stc, items: conditionItems };
      } else ret = refCondition;
      let xOption = this.refPageMode == 'R2' ? this.treeOption : this.tableOption;
      if (xOption.relCondition) {
        if (!ret) ret = {};
        let relCondition = this.Utility.fmtExpress(xOption.relCondition, Vue.ls.get('loginUser'));
        ret.condition = relCondition;
      }
      return ret;
    },
    _getSort (option) {
      let sortBy = !option ? [] : option.sortBy;
      if (sortBy.length) {
        let sort = [];
        for (let i = 0, l = sortBy.length; i < l; i++) {
          let code = sortBy[i];
          let item = this.tableOption.tableItems.find(m => m.code == code);
          sort.push({ code: item.path || code, type: option.sortDesc[i] ? 'desc' : 'asc' });
        }
        return sort;
      }
      return null;
    },
    _doLoadPageOption (callback) { // 参照框: 加载参照页面配置
      let opt = sessionStorage.getItem(`PAGE_OPTION_${this.option.refPage}`);
      if (!opt) {
        this.Framework.loadPageOption(this.option.refPage).then(res => {
          opt = res.data;
          sessionStorage.setItem(`PAGE_OPTION_${this.option.refPage}`, JSON.stringify(opt));
          this.refModel.pageOption = opt;
          callback()
        }).finally(() => this.optionLoaded = true)
      } else {
        this.refModel.pageOption = JSON.parse(opt);
        callback();
        this.optionLoaded = true;
      }
    },
    _setRefValue () {
      let value = this.refData;
      let n1 = !this.refId, n2 = value.length == 0;
      let changeFlag = (n1 && !n2) || (!n1 && n2) || (!n1 && !n2 && !this.option.multi && this.refId != (value[0]['ID']));
      if (this.option.multi && !n1 && !n2) {
        if (this.refId.length != value.length) {
          changeFlag = true;
        } else {
          let valueIds = [];
          value.forEach(v => valueIds.push(v['ID']));
          let v1 = JSON.stringify(this.Utility.clone(this.refId).sort());
          let v2 = JSON.stringify(valueIds.sort());
          if (v1 != v2) changeFlag = true;
        }
      }
      if (changeFlag) {
        if (n2) {
          this.dataList = [];
          this.refId = null;
          this.$set(this.billData, this.option.code, {});
        } else {
          this.dataList = [...value];
          if (this.option.multi) {
            let refId = [];
            value.forEach(v => refId.push(v['ID']));
            this.refId = refId;
          } else {
            this.refId = value[0]['ID'];
          }
          this.$set(this.billData, this.option.code, this.option.multi ? value : value[0]);
        }
        this.$emit('change', this.option.multi ? value : value[0]);
      }
    },
    _initValue (value) {
      if (this.option.multi) {
        this.refData = value && value.length ? value : [];
      } else {
        this.refData = value && value['ID'] ? [value] : [];
      }
      this.refModel.selectedRows = this.Utility.clone(this.refData);
      this._setRefValue();
    }
  },
  created () {
    this.$watch(`billData.${this.option.code}`, this._initValue);
    this._initValue(this.billData[this.option.code]);
    this.onSearchValueChanged = debounce(300, (e) => {
      this.searchValue = e;
      if (!e) {
        return;
      }
      let item = this.refId && this.refId != 0 && this.dataList.length && this.Utility.findById(this.dataList, this.refId);
      if (item && item[this.nameAttr] == e) {
        this.searchValue = '';
        return;
      }
      let callback = () => { this.onSearchInputDataQuery() }
      if (!this.optionLoaded) {
        this._doLoadPageOption(callback);
      } else {
        callback();
      }
    })
  }
}
</script>